import { MdOutlineError } from 'react-icons/md';
import { AircraftIcon } from '@icons';
import { SupplementalLiftAviaLeg, TxCenterProviderAviaLeg } from '@/api/apis/route';

const checkCrewData = (leg: SupplementalLiftAviaLeg | TxCenterProviderAviaLeg) => {
  return (
    leg.firstCrewMember.firstName &&
    leg.firstCrewMember.lastName &&
    leg.firstCrewMember.phoneNumber &&
    leg.secondCrewMember.firstName &&
    leg.secondCrewMember.lastName &&
    leg.secondCrewMember.phoneNumber
  );
};

type AirProviderLegInfoProps = {
  leg: SupplementalLiftAviaLeg | TxCenterProviderAviaLeg;
};

export const AirProviderLegInfo = ({ leg }: AirProviderLegInfoProps) => {
  const hasData = !!leg.tailNumber && checkCrewData(leg);

  return !hasData ? (
    <div className="w-max flex px-1 py-0.5 rounded-[4px] gap-1 bg-base-70">
      <div className="text-danger-30">
        <MdOutlineError size={16} />
      </div>
      <AircraftIcon />
      <span className="text-s-r text-base-10">Data is missing</span>
    </div>
  ) : null;
};
